import React from "react";
import Input from "./Input";

interface ExtractOptionsData {
  IsMultiline?: boolean;
  IsMultiple?: boolean;
  DelimiterStart?: string;
  DelimiterEnd?: string;
  CSV?: string[];
}

interface ExtractOptionsProps {
  options: ExtractOptionsData;
  onChange: (options: ExtractOptionsData) => void;
}

export default function ExtractOptions({ options, onChange }: ExtractOptionsProps) {
  return (
    <>
      <div className="mb-3">
        <Input
          label="Is multiline?"
          inputHelp="Ignore newline break"
          inputType="select"
          isSearchable={false}
          options={[
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ]}
          value={[options.IsMultiline || false]}
          onChange={(values) =>
            onChange({
              ...options,
              IsMultiline: values[0],
            })
          }
        />
      </div>
      <div className="mb-3">
        <Input
          label="Is multiple?"
          inputHelp="Is Multiple?"
          inputType="select"
          isSearchable={false}
          options={[
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ]}
          value={[options.IsMultiple || false]}
          onChange={(values) => onChange({ ...options, IsMultiple: values[0] })}
        />
      </div>
      <div className="mb-3">
        <Input
          label="Start delimiter"
          inputHelp="Start delimiter"
          value={[options.DelimiterStart]}
          onChange={(values) =>
            onChange({ ...options, DelimiterStart: values[0] })
          }
        />
      </div>
      <div className="mb-3">
        <Input
          label="End delimiter"
          inputHelp="End delimiter"
          value={[options.DelimiterEnd || ""]}
          onChange={(values) =>
            onChange({ ...options, DelimiterEnd: values[0] })
          }
        />
      </div>
      <div className="mb-3">
        <Input
          label="Separators"
          isMulti
          inputHelp="Separator between values"
          value={options.CSV || []}
          onChange={(values) => onChange({ ...options, CSV: values })}
        />
      </div>
    </>
  );
}
